<template>
  <teleport v-if="isLoadDom" to=".table-layout-quick">
    <div class="quick-layout">
      <component class="quick-icon" v-if="objInfo?.icon" :is="objInfo?.icon" />
      <!-- 线索池和线索公用设置，101直接显示线索池，其他正常显示对象名称 -->
      <span class="quick-title">{{ entity != 101 ? objInfo?.name : '线索池' }}</span>
      <jw-dropdown @select="selectQuick" position="bl" v-if="entity != 101 && objInfo?.name && userInfo?.roles?.indexOf(entity >= 200 ? 'object:custom' : 'object:system') !== -1">
        <span class="quick-btn hand"><qfei-icon-more-one-outlined class="icon-more" /></span>
        <template #content>
          <jw-doption :value="1">{{ $t('表单设计') }}</jw-doption>
          <jw-doption :value="3">{{ $t('视图设置') }}</jw-doption>
        </template>
      </jw-dropdown>
    </div>
  </teleport>
  <div class="comp-fh-list-container">
    <jw-card :bordered="false">
      <!-- data.tabInfo 默认是 null  默认加载 xl-tab -->
      <template v-if="data.tabInfo === null || data.tabInfo?.tabList?.length" #title>
        <div class="view-btn">
          <div class="view-btn-menu">
            <xl-tab ref="viewTabRef" :key="refreshTabKey" @cb="getViewId" @viewCb="viewCb" :entity="entity"></xl-tab>
          </div>
          <div class="view-btn-extra" v-if="data.tabInfo?.viewId && !isFrame && !isFrameTarget">
            <ly-list-universal-buttons v-if="hasUniversalBtns" :entityId="entity" :universalButtonParams="universalButtonParams" :totalCount="data.totalCount" ref="lyListUniversalButtonsRef" @cb="universalRefreshList" @cbAdd="cbAdd"></ly-list-universal-buttons>
            <div v-else class="view-btn-extra-skeleton">
              <template v-for="e in 4" :key="e">
                <span class="view-btn-extra-skeleton-item"> </span>
              </template>
            </div>
          </div>
        </div>
      </template>
      <!-- 操作区域 (新增按钮-排序-分组-列设置 等等) 外链容器不展示操作区域 - s  -->
      <div class="filter-wrap-layout" v-if="data.tabInfo?.viewId && !isFrame && !isFrameTarget">
        <div class="title-split">
          <!--此处的columnFieldList是全量字段，在排序组件会过滤掉不支持的字段  -->
          <!-- 高级筛选 S -->
          <ly-advanced-filter v-if="isShowFilter" :groupInfo="groupInfo" :entity="entity" :viewId="viewId" :viewClass="data.tabInfo?.viewClass || 10" :dataPermission="dataPermission" :dropdownFieldList="dropdownFieldList" :dropdownLoading="dropdownLoading" @cb="getSearchData" :universalButtonParams="universalButtonParams" @cbGroup="openListGroup" @cbSort="sortChange" :lyListLayout="lyListLayoutRef"></ly-advanced-filter>
          <div v-else class="title-split-skeleton">
            <div class="title-split-skeleton-select"></div>
            <div class="title-split-skeleton-select title-split-skeleton-field"></div>
            <template v-for="e in 3" :key="e">
              <div class="title-split-skeleton-icon"></div>
            </template>
          </div>
          <!-- 高级筛选 E -->
          <jw-button size="small" class="view-btn-right-btn list-container-btn" @click="refreshList" :disabled="!isShowFilter || tableDataLoading">
            <template #icon>
              <qfei-icon-update-outlined />
            </template>
            <template #default> 刷新</template>
          </jw-button>
        </div>
      </div>
      <!-- 操作区域 (新增按钮-排序-分组-列设置 等等) - e  -->
      <div :key="viewId + entity + refreshTabViewKey">
        <!-- 外链-内 -->
        <xl-iframe v-if="isFrame" :height="windowHeight" :query="{ entity: entity }" :src="frameData?.pcUrl" />
        <!-- 外链-外 -->
        <xl-no-view v-else-if="isFrameTarget" :type="1" @cb="openLink"></xl-no-view>
        <!-- 无视图 -->
        <xl-no-view v-else-if="data.tabInfo?.viewId === 0" @cb="addFirstView"></xl-no-view>
        <!-- 表格 -->
        <template v-else>
          <template v-if="isShowListOrGroup">
            <!-- 分组列表 -->
            <fh-main-table-group v-if="groupInfo?.length" :maxHeight="listScroll" :groupInfo="groupInfo" :key="randomKey" :viewId="viewId" :entityId="entity" ref="lyListLayoutRef" :conditionsType="conditionsTypeObj" :viewsObj="viewsObj" v-model:loading="tableDataLoading" :allFieldsList="allFieldsList" :allFieldsListObj="allFieldsListObj" @cb="getTableParams" class="ly-list-layout-table" :shortcutBtnPermission="shortcutBtnPermission" :batchBtnPermission="batchBtnPermission" @loadAdvancedComp="loadAdvancedComp" :buttonUniversalAdd="buttonUniversalAdd" @cbAdd="cbAdd" @cbTotalCount="setTotalCount" />
            <!-- 列表 -->
            <fh-main-table v-else :maxHeight="listScroll" :viewId="viewId" :entityId="entity" :conditionsType="conditionsTypeObj" :viewsObj="viewsObj" v-model:loading="tableDataLoading" ref="lyListLayoutRef" :allFieldsList="allFieldsList" :allFieldsListObj="allFieldsListObj" @cb="getTableParams" class="ly-list-layout-table" :shortcutBtnPermission="shortcutBtnPermission" :batchBtnPermission="batchBtnPermission" @loadAdvancedComp="loadAdvancedComp" :buttonUniversalAdd="buttonUniversalAdd" @cbAdd="cbAdd" @cbTotalCount="setTotalCount" />
          </template>
          <fh-list-skeleton v-else />
        </template>
      </div>
    </jw-card>
    <!-- 视图新建 -->
    <vu ref="vuRef" :entity="entity" @cb="cbVu"></vu>
    <!-- 编辑对象弹窗（表单设计，表单配置，表单发布） @cb="formCb" -->
    <object-form ref="formRef" @cb="formCb" />
    <fh-add-edit ref="addEditRef" @cb="universalRefreshList" />
  </div>
  <!-- AI汇总 -->
  <transition name="slide-fade">
    <fh-ai-summary v-if="activeAiData" :key="activeAiData.id" :data="activeAiData" :entityId="entityId" @close="closeAiSummary" />
  </transition>
</template>

<script setup>
import { ref, computed, reactive, nextTick, defineAsyncComponent, onMounted, watch, onBeforeUnmount, provide } from 'vue';
import XlIframe from '@/components/xl-iframe/xl-iframe.vue';
import XlNoView from '@/components/xl-no-view/xl-no-view.vue';
import FhListSkeleton from '@/components/fh-list/fh-list-skeleton/fh-list-skeleton.vue';
// import FhBoardView from '@/components/fh-list/fh-board-view/fh-board-view.vue';
import LyListUniversalButtons from '@/components/layout/ly-list-universal-buttons/ly-list-universal-buttons.vue'; //列表--公共按钮组件
import FhMainTable from '@/components/fh-list/fh-main-table/fh-main-table.vue';
import FhMainTableGroup from '@/components/fh-list/fh-main-table-group/fh-main-table-group.vue';
import { QfeiIconUpdateOutlined, QfeiIconMoreOneOutlined } from '@qfei-design/icons-vue';
import { objEntityMapping } from '@/utils/const';
const oem = ref(JSON.parse(JSON.stringify(objEntityMapping)));
import { useRoute } from 'vue-router';
import useEventListener from '@/hooks/event-listener';
import { useFilterListStore, useUserStore, useGrayscaleStore } from '@/store';
import useMainTable from '@/hooks/main-table';
import { tools } from '@/utils/tools';
import FhAiSummary from '@/components/fh-ai-summary/fh-ai-summary.vue';

const grayListStore = useGrayscaleStore();
const ObjectForm = defineAsyncComponent(() => import('@/views/setting/sys-fields/components/object-form/index.vue'));
const vu = defineAsyncComponent(() => import('@/views/setting/sys-fields/page-layout/components/view-update/view-update.vue'));
const { getFilterAndUniversalBtn, dropdownFieldList, dropdownLoading, buttonUniversal, conditionsType, getFieldsConditions, allFieldsList, allFieldsListObj, getAllFields, batchBtnPermission, shortcutBtnPermission, getBatchAndQuickBtn } = useMainTable();
const useFilterList = useFilterListStore();
// const useTableInfo = useMainTableStore();
const route = useRoute();
const { eventListener } = useEventListener();
const props = defineProps({
  entityId: {
    //对象的entity【系统对象时必传】
    type: Number || String,
    default: ''
  }
});
const { userInfo } = useUserStore(); //用户信息
const entity = computed(() => Number(props.entityId || route?.params?.entity));
const isShowListOrGroup = ref(false);
const tableDataLoading = ref(false);
/****************视图相关********************** */
const lyListLayoutRef = ref();
const viewId = ref(-1);
const viewsObj = ref(null);
const isFrame = ref(false);

// AI汇总
const aiSummaryEnabled = computed(() => {
  // 租户判断
  if (!grayListStore.grayList?.['Layout:aiSummary']) return false;
  return [
    1292, // test
    272, // pre
    212, // pre
    204 // prod
  ].includes(+entity.value);
});
const activeAiData = ref(null);
const setActiveData = (data) => {
  activeAiData.value = data;
};
const closeAiSummary = (e) => {
  // 点击当前打开的汇总图标不关闭
  const target = e?.composedPath()?.find((x) => x.classList?.contains('index-ai-icon'));
  if (!target || +target.dataset.id !== activeAiData.value?.id) {
    activeAiData.value = null;
  }
};

provide(
  'aiSummaryOptions',
  computed(() => ({
    enabled: aiSummaryEnabled.value,
    setActiveData,
    closeAiSummary
  }))
);

// 外部链接
const isFrameTarget = ref(false);
// 视图数据
const data = reactive({
  tabInfo: null,
  totalCount: 0 // 总条数
});
const frameData = ref({}); //外链跳转信息
const hasGroup = ref(false); //是否有分组
const groupInfo = ref([]); //分组信息
const randomKey = ref(0);
const hasUniversalBtns = ref(false); //是否有公共按钮
const buttonUniversalAdd = ref(null); // 新建按钮权限
// const columnFieldList = ref([]);
/************************动态控制列表高度 Start************************* */
const windowHeight = ref(window.innerHeight - 140 > 0 ? window.innerHeight - 140 : 200);
const eventListen = () => {
  windowHeight.value = window.innerHeight - 140 > 0 ? window.innerHeight - 140 : 200;
};
const listScroll = ref(null);
eventListener('resize', eventListen);
const stopHeightWatch = watch(
  () => windowHeight.value,
  (v) => {
    listScroll.value = v > 360 ? v - 60 : 300;
  },
  {
    deep: true,
    immediate: true
  }
);
/************************动态控制列表高度 End************************* */
const isShowFilter = ref(false);
const dataPermission = ref(0);
const heighFilterParams = ref({});
const lyListUniversalButtonsRef = ref();
const conditionsTypeObj = ref({});
const viewTabRef = ref(null);
const vuRef = ref();
const setTotalCount = (totalCount) => {
  data.totalCount = totalCount;
};
const addFirstView = () => {
  vuRef.value.openDrawer();
};
const refreshTabViewKey = ref(0);
const viewCb = () => {
  refreshTabViewKey.value = refreshTabViewKey.value + 1;
};

const refreshTabKey = ref(0);
const cbVu = (params) => {
  if (params.isRefresh) {
    data.tabInfo = null;
    nextTick(() => {
      refreshTabKey.value = refreshTabKey.value + 1;
    });
  }
};

const openLink = () => {
  window.open(frameData.value?.pcUrl, '_blank');
};

// 获取外链相关逻辑
const getFrame = (views) => {
  if (views?.selectTab?.type === '30') {
    viewId.value = views?.viewId;
    const _frameData = JSON.parse(views?.selectTab?.businessData);
    if (_frameData?.openWith == 1) {
      window.open(_frameData?.pcUrl, '_blank');
      isFrameTarget.value = true;
    } else {
      isFrame.value = true;
    }
    frameData.value = _frameData;
    return false;
  }
  isFrame.value = false;
  frameData.value = {};
};
//兼容移动端链接直接在列表打开新建、编辑、复制的callback
/******************* 移动端链接兼容 start **********************/
const addEditRef = ref();

const compatibleMobile = () => {
  nextTick(() => {
    const _routeParams = route.params?.id?.split('-');
    const params = {
      id: _routeParams?.[3] || '',
      type: _routeParams?.[0] == 'update' ? 40 : 30,
      viewId: _routeParams?.[2] || -1,
      entity: entity.value,
      copy: _routeParams?.[0] == 'copy' || undefined
    };
    console.log(params);
    addEditRef.value?.open(params);
  });
};
/******************* 移动端链接兼容 end **********************/

// 公共新增按钮
const cbAdd = (params) => {
  addEditRef.value?.open(params);
};
// 获取视图ID
const getViewId = async (views) => {
  data.tabInfo = views;
  if (data.tabInfo?.tabList?.length === 0) return;
  isFrameTarget.value = false;
  isFrame.value = false;
  hasGroup.value = views?.hasGroup; //是否有分组
  console.log(views, 'console.log(views.groupInfo');
  groupInfo.value = views?.groupInfo && views?.groupInfo?.length ? JSON.parse(JSON.stringify(views?.groupInfo)) : []; //分组信息
  isShowListOrGroup.value = false;
  useFilterList.setIsFirst(true);
  isShowFilter.value = false;
  conditionsTypeObj.value = {}; //清空筛选条件类型
  /***** 外链容器兼容 start *****/
  getFrame(views);
  /***** 外链容器兼容 end *****/

  //给快捷设置布局添加forceRefresh 因为布局返回后需要强制刷新
  if (viewId.value === views.viewId && views.refresh) return;
  // 获取视图后先清空分组
  viewId.value = views?.viewId;
  viewsObj.value = views;
  dataPermission.value = views?.dataPermission; //数据权限
  isShowListOrGroup.value = true;

  await nextTick(); //等待表格渲染完成后再打开详情页（去掉后不能从路由跳转详情页）
  // 如果路由中有id，则打开详情页
  if (route.params?.id && !useFilterList.routerBusinessId) {
    if (route.params?.id?.indexOf('-') > -1) {
      //移动端路由兼容
      compatibleMobile();
    } else {
      //获取路由参数id，打开一次详情，下次不再打开
      lyListLayoutRef.value?.toDetails({ id: route.params.id });
      // 将路由参数id存入store中
      useFilterList.updateRouterBusinessId(route.params.id);
    }
  }
};
const getAddBtn = () => {
  if (entity.value >= 200) {
    oem.value[entity.value] = entity.value;
  }
  const addBtn = buttonUniversal.value?.find((item) => item.value == `${oem.value[entity.value]}:add`);
  const btnType = tools.getShowTypeByEntity(userInfo?.menus?.entityResources, entity.value);
  buttonUniversalAdd.value = null;
  if ((btnType?.[`${oem.value[entity.value]}:add`] == 0 || btnType?.[`${oem.value[entity.value]}:add`] == 2) && addBtn) {
    buttonUniversalAdd.value = addBtn;
  }
};
// 提取接口调用逻辑，统一管理
const requestIdleTaskApi = async () => {
  // 获取下拉筛选字段和公共按钮
  await getFilterAndUniversalBtn({ entity: entity.value, viewId: viewId.value });
  hasUniversalBtns.value = true; //开始加载通用按钮组件
  nextTick(() => {
    lyListUniversalButtonsRef.value?.getBtnPermissionObj(buttonUniversal.value); //获取按钮权限
  });
  // 获取对象下所有字段
  if (allFieldsList.value?.length === 0) {
    await getAllFields({ entity: entity.value });
  }
  // 获取字段筛选条件类型
  if (Object.keys(conditionsType.value)?.length === 0) {
    await getFieldsConditions();
    conditionsTypeObj.value = conditionsType.value;
  }
  // 再不调用接口时保证以下组件能接收到参数的变化(列表和分组组件中都有对该字段的监听)
  conditionsTypeObj.value = JSON.parse(JSON.stringify(conditionsType.value));
  // 当所有回显参数准备完成后再加载筛选组件
  // 此处如果初始化有排序，而列表已经渲染完成，需要将排序字段fieldSort添加到columns中并且重新渲染表头，否则表头排序图标不展示
  // lyListLayoutRef.value?.columnsAddSort();
  // 在此处调用获取公共按钮和快捷按钮接口(首屏页面不展示，用户勾选才展示)

  getBatchAndQuickBtn({ entity: entity.value, viewId: viewId.value });

  // 获取新建按钮
  getAddBtn();

  if (!groupInfo.value?.length) {
    lyListLayoutRef.value?.getSummaryData();
  }
};
/****************视图相关********************** */

// 筛选条件
const universalButtonParams = ref({});
//高级筛选组件中分组的回调事件，判断是否有分组的

const groupFieldList = ref([]);
const openListGroup = async (fg) => {
  console.log(123456, 204, fg);
  groupInfo.value = JSON.parse(JSON.stringify(fg)); //重新将最新的分组信息赋值给分组字段
  if (fg?.length) {
    // 本身就有分组时，需要重新加载一次分组组件
    if (viewsObj.value?.viewClass == '30') {
      //如果是看板视图 重新设置分组信息，因为看板中有根据group填充选项逻辑
      viewsObj.value.groupInfo = fg;
    }
    if (hasGroup.value) {
      randomKey.value++;
      return;
    } else {
      hasGroup.value = true;
    }
    viewTabRef.value?.resetHasGroup?.({ viewId: viewId.value, hasGroup: true, groupInfo: fg }); //重置分组
  } else {
    hasGroup.value = false;
    groupInfo.value = [];
    viewTabRef.value?.resetHasGroup?.({ viewId: viewId.value, hasGroup: false, groupInfo: [] }); //重置分组
  }
};
// 开始加载高级筛选组件
const loadAdvancedComp = () => {
  isShowFilter.value = true;
  // 先渲染列表，然后开始加载高级筛选组件，再获取其他条件数据
  requestIdleTaskApi();
};
/************* 快捷打开设置 start **************/
const formRef = ref();
const objInfo = computed(() => {
  const data = userInfo?.menus?.entityResources?.find((item) => entity.value && item?.entity == entity.value);
  return {
    icon: data?.icon ?? '',
    name: data?.title ?? ''
  };
});
const selectQuick = (value) => {
  const params = {
    entity: entity.value,
    name: objInfo.value?.name,
    type: 'addObj', //新建对象自动跳转后的标记，用来做返回刷新列表使用
    key: value
  };
  formRef.value.onOpen(params); //打开弹窗
};
/***********************公共按钮 start*************************** */
// 公共按钮组件事件回调
const universalRefreshList = async (type) => {
  console.log('新建编辑组件回调', type);
  if (type === 'cancel') return; //新建组件取消按钮
  if (hasGroup.value) {
    lyListLayoutRef.value.getLoadTableList(undefined, false);
  } else {
    lyListLayoutRef.value.universalRefreshList();
  }
};
const getTableParams = (params) => {
  console.log('conditionsList-7', params);
  universalButtonParams.value = params;
  // 按钮权限更新
  if (buttonUniversal?.length) {
    // 改动点：直接传递公共按钮的数组，之前是传递整个按钮对象，其中包含多个按钮数组，所以需要修改
    lyListUniversalButtonsRef.value?.getBtnPermissionObj(buttonUniversal);
  }
};
/*************************公共按钮 end*************************** */

/**************************高级筛选 S******************************* */
// 打开列选择
const getSearchData = (v, searchType) => {
  groupFieldList.value = v?.groupFieldList;
  heighFilterParams.value = v;
  // 搜索条件
  lyListLayoutRef.value?.getSearchData(v, searchType);
};
// 刷新列表
const refreshList = () => {
  lyListLayoutRef.value?.refreshList('refresh');
};
/**************************高级筛选 E******************************* */
const formCb = () => {
  //2025年02月21日17:07:35产品敲定从表单/布局设置过来直接浏览器刷新
  window.location.reload();
};
const sortChange = (v) => {
  console.log('sortChange-container', v);
  lyListLayoutRef.value.sortChange(v);
};

const isLoadDom = ref(false);
onMounted(() => {
  isLoadDom.value = document.querySelector('.table-layout-quick');
});
onBeforeUnmount(() => {
  console.log(1589, 'lyList组件销毁了');
  lyListLayoutRef.value = null;
  formRef.value = null;
  isFrame.value = false;
  objInfo.value = null;
  viewId.value = null;
  stopHeightWatch();
});
</script>
<style scoped lang="less">
@import './fh-list-container.less';
</style>
